import React from 'react';
import styled from 'styled-components';
import * as AppActions from '../../AppActions';

const F = AppActions.F;

export default function TeamIntorduction(props) {
  const {data} = props;
  const [paragraphs, setParagraphs] = React.useState(null);

  React.useEffect(() => {
    if (
      data &&
      data.content &&
      Array.isArray(data.content) &&
      data.content.length > 0 &&
      !paragraphs
    ) {
      let _paragraphs = [];

      for (let i = 0; i < data.content.length; i++) {
        const it = data.content[i];
        const isImageAndTextAround = !!it.image && !!it.text;

        if (isImageAndTextAround) {
          _paragraphs.push(i);
        }
      }

      setParagraphs(_paragraphs);
    }
  }, [data, paragraphs]);

  if (!data) {
    return <Wrapper />;
  }

  return (
    <Wrapper>
      <div className="title">
        <h2>{F(data, 'title')}</h2>
      </div>
      <div className="container">
        {data.content.map((it, index) => {
          const isImageOnly = !!it.image && !it.text;
          const isTextOnly = !it.image && !!it.text;

          if (isImageOnly) {
            return (
              <div className="image-only-item">
                <div className="image">
                  <img alt={it.image} src={it.image} style={{width: '100%'}} />
                  <div className="text">{F(it, 'image_text')}</div>
                </div>
              </div>
            );
          } else if (isTextOnly) {
            return (
              <div className="text-only-item">
                <div className="text">{F(it, 'text')}</div>
              </div>
            );
          }

          const isOddPosition =
            paragraphs &&
            Array.isArray(paragraphs) &&
            paragraphs.length > 0 &&
            paragraphs.findIndex((p) => p === index) % 2 === 1;

          return (
            <div className="float-item">
              <div className={`image ${isOddPosition ? 'left' : 'right'}`}>
                <img alt={it.image} src={it.image} style={{width: '100%'}} />
                <div className="text">{F(it, 'image_text')}</div>
              </div>
              <div className="text">{F(it, 'text')}</div>
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 60px;

  & > .title {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  & > .container {
  }

  .image-only-item {
    margin-bottom: 10px;

    & > .image > .text {
      margin-top: 5px;
      margin-bottom: 5px;
      text-align: center;
    }
  }

  .text-only-item {
    margin-bottom: 10px;

    & > .text {
      line-height: 1.8rem;
      font-size: 1rem;
    }
  }

  .float-item {
    & > .image {
      margin-top: 5px;
      margin-bottom: 5px;
      max-width: 290px;
      width: 100%;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    & > .image.right {
      float: right;
      padding-left: 10px;
      padding-bottom: 5px;
    }

    & > .image.left {
      float: left;
      padding-right: 10px;
      padding-bottom: 5px;
    }

    & > .image > .text {
      margin-top: 5px;
      margin-bottom: 5px;
      text-align: center;
    }

    & > .text {
      margin-bottom: 10px;
      line-height: 1.8rem;
      font-size: 1rem;
    }

    @media screen and (max-width: 500px) {
      display: flex;
      flex-direction: column-reverse;

      & > .image {
        max-width: 100%;
      }

      & > .image.right,
      .image.left {
        float: none;
        padding-right: 0px;
        padding-left: 0px;
        padding-bottom: 0px;
      }
    }
  }
`;
